var _excluded = ["theme"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/theme/index.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { createContext } from 'react';
import { WrenchTheme } from '@wds/styles';
import { createTheming, ThemeProvider } from 'react-jss';
import { WrenchHeaderTheme } from './themes';
var HeaderThemeMapper = {
  wrench: WrenchHeaderTheme
};
var ThemeMapper = {
  wrench: WrenchTheme
};
var ThemeContext = /*#__PURE__*/createContext(WrenchHeaderTheme);
var theming = createTheming(ThemeContext);
var HeaderThemeProvider = theming.ThemeProvider,
  useHeaderTheme = theming.useTheme;
var withHeaderTheme = function withHeaderTheme(Component) {
  return function (_ref) {
    var theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: ThemeMapper.wrench,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(HeaderThemeProvider, {
      theme: HeaderThemeMapper.wrench,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 11
      }
    }))));
  };
};
export { HeaderThemeProvider, useHeaderTheme, withHeaderTheme };
//# sourceMappingURL=index.js.map